
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-south-1_0eYVP2TXR',
      userPoolClientId: '3hdc1a44ititgj8mp5m2mdkm5n',
      region: 'ap-south-1'
    }
  }
};


